import React from 'react'
import { responseError } from '../../../helpers/response/ResponseHelper'
import { useState } from 'react'
import { useEffect } from 'react'
import SupplyBillItemsAllTable from './SupplyBillItemsAllTable'
import { getSupplyBillAllItems } from '../../../api/supply/supplyBillItemAPI'
import { useDispatch, useSelector } from 'react-redux'
import { setSupplyBillsItemsAllCount, setSupplyBillsItemsAllLimit, setSupplyBillsItemsAllList, setSupplyBillsItemsAllOffset } from '../../../store/supplyBillSlice'

const SupplyBillItemsAllList = () => {

    const supplyBillItems = useSelector(state => state.supplyBill.supplyBillsItemsAll.list)
    const count = useSelector(state => state.supplyBill.supplyBillsItemsAll.count)
    const limit = useSelector(state => state.supplyBill.supplyBillsItemsAll.limit)
    const offset = useSelector(state => state.supplyBill.supplyBillsItemsAll.offset)
    const query = useSelector(state => state.supplyBill.supplyBillsItemsAll.query)
    const status = useSelector(state => state.supplyBill.supplyBillsItemsAll.filters.status)
    const agreeNachSupply = useSelector(state => state.supplyBill.supplyBillsItemsAll.filters.agreeNachSupply)
    const agreeEconomist = useSelector(state => state.supplyBill.supplyBillsItemsAll.filters.agreeEconomist)
    const agreeDeputyDirectorSupply = useSelector(state => state.supplyBill.supplyBillsItemsAll.filters.agreeDeputyDirectorSupply)
    const agreeHeader = useSelector(state => state.supplyBill.supplyBillsItemsAll.filters.agreeHeader)
    const dispatch = useDispatch()

    // const [count, setCount] = useState(0)
    // const [limit, setLimit] = useState(10)
    // const [offset, setOffset] = useState(0)
    // const [query, setQuery] = useState('')

    // const [supplyBillItems, setSupplyBillItems] = useState([])
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')

    useEffect(() => {
        setLoading(true)
        setError('')
        getSupplyBillAllItems({ 
            offset, limit, query, status, agreeNachSupply, agreeEconomist, agreeDeputyDirectorSupply, agreeHeader 
        }).then(data => {
            // setCount(data.count)
            // setSupplyBillItems(data.supplyBillItems)
            dispatch(setSupplyBillsItemsAllCount(data.count))
            dispatch(setSupplyBillsItemsAllList(data.supplyBillItems))
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }, [limit, offset, query, status, agreeNachSupply, agreeEconomist, agreeDeputyDirectorSupply, agreeHeader])

  return (
    <div>
        <SupplyBillItemsAllTable
            supplyBillItems={supplyBillItems}
            count={count}
            limit={limit}
            setLimit={e => dispatch(setSupplyBillsItemsAllLimit(e))}
            offset={offset}
            setOffset={e => dispatch(setSupplyBillsItemsAllOffset(e))}
            loading={loading}
        />
    </div>
  )
}

export default SupplyBillItemsAllList